import { FORTA_GRAY3 } from '../../../../../utils/colors';

import type { SxProps, Theme } from '@mui/material';

export const INFORMATION_SECTION_CARD_SX: SxProps<Theme> = {
  p: 2,
  height: '100%',
  border: `1px solid ${FORTA_GRAY3}`,
  borderRadius: '10px',
};
